<script>
  import AddGroup from './chat/mobile/AddGroup.svelte';
  import AddUser from './chat/mobile/AddUser.svelte';

  export let type = 'user';
  export let showTitle = true;
  export let formWidth = false;
  export let onClose = () => {};
  export let onSubmit = () => {};

  function handleCreated(conversation) {
    onSubmit?.({
      type,
      conversation
    });
  }
</script>

<div class="w-full" style={formWidth ? `width:${formWidth};max-width:100%;` : ''}>
  {#if type === 'group'}
    <AddGroup {showTitle} {onClose} onCreated={handleCreated} />
  {:else}
    <AddUser {showTitle} {onClose} onCreated={handleCreated} />
  {/if}
</div>
